const name = 'FREEBET-SET-BET'

async function execute() {
  const freeBetModel = game.models.FreebetsModel.get()
  const { BetModel, SpinModel } = game.models

  freeBetModel.regularBetToRestore = BetModel.getValue()

  const newBetValue = freeBetModel.betValue * SpinModel.get().lines
  game.models.BetModel.setValue(newBetValue)
}

export function getFreeBetSetBetAction() {
  return {
    name,
    execute,
  }
}
